import { Card, CardHeader, CardContent, Stack, Box, Button, Typography, useTheme } from "@mui/material";
import { useForm } from "react-hook-form";
import Icon from "src/@core/components/icon";
import { ControlledTextField } from "src/components/forms";
import { DropzoneField } from "src/components/forms/DropzoneField";

type Mensaje = {
    titulo?: string,
    mensaje: string,
    fecha: string,
    de: 'otro' | 'yo',
}

const Mensajes: Mensaje[] = [
    {
        titulo: 'Documentación requerida',
        mensaje: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, vitae a semper nunc nisl eget urna. ',
        fecha: 'Ayer 12:07',
        de: 'otro',
    },
    {
        titulo: 'Documentación requerida',
        mensaje: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, vitae a semper nunc nisl eget urna. ',
        fecha: 'Ayer 12:07',
        de: 'yo',
    },
    {
        titulo: 'Documentación requerida',
        mensaje: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, vitae a semper nunc nisl eget urna. ',
        fecha: 'Ayer 12:07',
        de: 'otro',
    },
    {
        titulo: 'Documentación requerida',
        mensaje: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, vitae a semper nunc nisl eget urna. ',
        fecha: 'Ayer 12:07',
        de: 'otro',
    },
    {
        titulo: 'Documentación requerida',
        mensaje: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, vitae a semper nunc nisl eget urna. ',
        fecha: 'Ayer 12:07',
        de: 'yo',
    },
    {
        titulo: 'Documentación requerida',
        mensaje: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, vitae a semper nunc nisl eget urna. ',
        fecha: 'Ayer 12:07',
        de: 'yo',
    },
    {
        titulo: 'Documentación requerida',
        mensaje: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, vitae a semper nunc nisl eget urna. ',
        fecha: 'Ayer 12:07',
        de: 'otro',
    },
    {
        titulo: 'Documentación requerida',
        mensaje: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, vitae a semper nunc nisl eget urna. ',
        fecha: 'Ayer 12:07',
        de: 'otro',
    },
]

const Mensaje = ({ mensaje }: { mensaje: Mensaje }) => {

    const theme = useTheme();

    return (
        <Box
            sx={{
                maxWidth: '60%',
                ...{
                    backgroundColor: (mensaje.de === 'yo' ? theme.palette.primary.main : theme.palette.grey[300])
                },
                borderRadius: '5px',
                padding: '5px',
            }
            }
            alignSelf={mensaje.de === 'yo' ? 'flex-end' : 'flex-start'}
        >
            <Stack>
                <Typography variant='h6'>{mensaje.titulo}</Typography>
                <Typography variant='body1'>{mensaje.mensaje}</Typography>
                <Typography variant='caption' align='right'>{mensaje.fecha}</Typography>
            </Stack>
        </Box>
    )
}

const SeccionChat = () => {

    return (
        <Box
            sx={{
                border: '2px solid gray',
                borderRadius: '10px',
                width: '100%',
                overflow: 'auto',
                padding: '10px',
            }}
            flexGrow={1}
        >
            <Stack spacing={4}>
                {
                    Mensajes.map((m, index) => (
                        <Mensaje
                            key={index}
                            mensaje={m}
                        />
                    ))
                }
            </Stack>
        </Box >
    )
}

const SeccionDocu = () => {

    const formMethods = useForm();

    return (
        <Box
            sx={{ width: '100%' }}
            flexShrink={1}
        >
            <Stack direction='row' spacing={2} display='flex' alignItems='center'>
                <Box flexGrow={.5} height={'100%'}>
                    <DropzoneField
                        name='dropzone_form'     // TODO: acá va el name del field del form que corresponde al archivo
                        multiple
                        control={formMethods.control}
                        setValue={formMethods.setValue}
                    />
                </Box>
                <Box flexGrow={.5} height={'100%'}>
                    <ControlledTextField
                        label='Comentarios adicionales'
                        name='comentarios-adicionales'
                        multiline
                        rows={3}
                        fullWidth
                        control={formMethods.control}
                    />
                </Box>
                <Button color='primary' variant='contained' startIcon={<Icon icon='mdi:send' fontSize={20} />}>
                    Enviar
                </Button>
            </Stack>
        </Box>
    )
}

const SolicitationInterchange = () => {

    // const theme = useTheme();

    return (
        <Card
        >
            <CardHeader
                title="Intercambio de documentación"
            />
            <CardContent
                sx={{
                    height: 'calc(100vh - 128px - 72px - 24px - 56px - 24px)',
                    overflow: 'auto',
                }}
            >
                <Stack
                    spacing={2}
                    display='flex'

                    sx={{
                        height: '100%',
                    }}
                >
                    <SeccionChat />
                    <SeccionDocu />
                </Stack>
            </CardContent>
        </Card>
    )
}

export default SolicitationInterchange;